import { useState } from 'react';

import { AbsoluteFill, interpolate, useCurrentFrame, useVideoConfig, Video } from 'remotion';

import { DEFAULT_TRANSITION_DURATION } from '@/constants';
import { OpacityLevel } from '@/enums/RemotionEnums';

type VideoPersonalAssetProps = {
  src: string;
};

export const VideoPersonalAsset: React.FC<VideoPersonalAssetProps> = ({ src }) => {
  const { fps, durationInFrames } = useVideoConfig();
  const currentFrame = useCurrentFrame();

  const [videoDimensions, setVideoDimensions] = useState<{
    videoAssetWidth: number;
    videoAssetHeight: number;
  }>();

  const videoOpacity =
    currentFrame < DEFAULT_TRANSITION_DURATION * fps
      ? interpolate(
          currentFrame,
          [0, DEFAULT_TRANSITION_DURATION * fps],
          [OpacityLevel.TRANSPARENT, OpacityLevel.OPAQUE]
        )
      : currentFrame > durationInFrames - DEFAULT_TRANSITION_DURATION * fps
        ? interpolate(
            currentFrame,
            [durationInFrames - DEFAULT_TRANSITION_DURATION * fps, durationInFrames],
            [OpacityLevel.OPAQUE, OpacityLevel.TRANSPARENT]
          )
        : OpacityLevel.OPAQUE;

  return (
    <AbsoluteFill className='pointer-events-none flex items-center justify-center'>
      <>
        {videoDimensions && videoDimensions.videoAssetWidth < videoDimensions.videoAssetHeight && (
          <Video
            src={src}
            style={{
              width: '100%',
              height: '100%',
              opacity: videoOpacity,
              objectFit: 'cover',
              filter: 'blur(80px) brightness(0.95)',
              transform: 'scale(1.30)'
            }}
          />
        )}
        <AbsoluteFill>
          <Video
            src={src}
            onLoadedMetadata={(e) => {
              setVideoDimensions({
                videoAssetWidth: e.currentTarget.videoWidth,
                videoAssetHeight: e.currentTarget.videoHeight
              });
            }}
            style={{
              width: '100%',
              height: '100%',
              opacity: videoOpacity,
              objectFit:
                videoDimensions &&
                videoDimensions.videoAssetWidth < videoDimensions.videoAssetHeight
                  ? 'contain'
                  : 'cover'
            }}
          />
        </AbsoluteFill>
      </>
    </AbsoluteFill>
  );
};
